import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {CustomerSearchDto} from "../model/CustomerSearchDto";

class CustomerSearchTableController {
    searchResults: CustomerSearchDto[];
    private rid: number;
    private searching: boolean;

    constructor(private $dataHub: DataHubService, private $scope) {
        this.$dataHub.onCustomerSearchResult((requestId, customer) => {
            if (requestId != this.rid) return;
            if (!customer) return;
            this.searchResults.merge(customer, x => x.guid);
        });
    }

    search = (input: string) => {
        this.searchResults = [];
        this.rid = Date.now();
        if (!this.$dataHub.isConnected) return;
        this.searching = true;
        this.$dataHub.customerSearch2(input, this.rid)
            .then()
            .catch(this.$dataHub.defaultErrorHandler)
            .finally(() => this.searching = false);
    }

}

export default angular.module('component.customerSearchTable', [])
    .component('customerSearchTable', {
        template: require('./CustomerSearchTable.html'),
        controller: CustomerSearchTableController,
        bindings: {}
    }).name;
